// ===================================================
// QUADRO SOCIETÁRIO — CONFIG
// ===================================================
window._cfgSocios=window._cfgSocios||[];
function _renderSociosCfg(){
  const el=document.getElementById('cfg-socios-list');if(!el)return;
  const s=window._cfgSocios;
  if(!s.length){el.innerHTML='<div style="font-size:12px;color:var(--muted);padding:6px 0">Nenhum sócio cadastrado.</div>';return;}
  el.innerHTML=`<div style="display:grid;gap:10px;margin-top:8px">${s.map((x,i)=>`
  <div style="display:grid;grid-template-columns:2fr 1fr 2fr 1fr auto 1fr auto;gap:8px;align-items:center;padding:10px 12px;background:var(--surface2);border-radius:8px;flex-wrap:wrap">
    <input id="socio-nome-${i}" class="si" placeholder="Nome completo" value="${escapeHtml(x.nome||'')}" style="font-size:12px">
    <input id="socio-cpf-${i}" class="si" placeholder="CPF" value="${escapeHtml(x.cpf||'')}" style="font-size:12px;font-family:monospace">
    <input id="socio-email-${i}" class="si" placeholder="E-mail" type="email" value="${escapeHtml(x.email||'')}" style="font-size:12px">
    <select id="socio-tipo-${i}" class="si" style="font-size:12px">
      <option value="socio_administrador"${x.tipo==='socio_administrador'?' selected':''}>Sócio administrador</option>
      <option value="socio"${x.tipo==='socio'||!x.tipo?' selected':''}>Sócio quotista</option>
      <option value="representante"${x.tipo==='representante'?' selected':''}>Representante legal</option>
      <option value="procurador"${x.tipo==='procurador'?' selected':''}>Procurador</option>
    </select>
    <input id="socio-pct-${i}" class="si" placeholder="%" type="number" min="0" max="100" step="0.01" value="${x.participacao||''}" style="font-size:12px;width:60px">
    <label style="font-size:11px;color:var(--muted);white-space:nowrap">% participação</label>
    <button class="btn btn-danger btn-sm" onclick="_removeSocio(${i})">✕</button>
  </div>`).join('')}</div>`;
}
function _addSocio(){
  window._cfgSocios.push({id:uid(),nome:'',cpf:'',email:'',tipo:'socio',participacao:0});
  _renderSociosCfg();
  const el=document.getElementById('cfg-socios-list');
  if(el){const inputs=el.querySelectorAll('input');if(inputs.length)inputs[inputs.length-4].focus();}
}
function _removeSocio(idx){
  window._cfgSocios.splice(idx,1);
  _renderSociosCfg();
}

